class AlgoliaCollectionResults extends HTMLElement {
  connectedCallback() {
    const query = new URLSearchParams(window.location.search).get('q');
    if (!query?.trim()) { this.hidden = true; return; }
    this.#search(query.trim());
  }

  async #search(query) {
    const { algoliaAppId: appId, algoliaApiKey: apiKey } = this.dataset;
    const indexName = this.dataset.algoliaIndex || 'shopify_collections';
    const limit = parseInt(this.dataset.limit, 10) || 6;

    try {
      const res = await fetch(`https://${appId}-dsn.algolia.net/1/indexes/${indexName}/query`, {
        method: 'POST',
        headers: {
          'X-Algolia-Application-Id': appId,
          'X-Algolia-API-Key': apiKey,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query,
          hitsPerPage: limit,
          attributesToRetrieve: ['title', 'handle', 'image', 'products_count'],
        }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const { hits } = await res.json();

      const filtered = hits.filter(h => h.products_count > 0 && h.handle !== 'shop-all');
      if (!filtered.length) { this.hidden = true; return; }

      this.#render(filtered);
      this.setAttribute('data-loaded', '');
    } catch (e) {
      console.error('Algolia collections search error:', e.message);
      this.hidden = true;
    }
  }

  #render(hits) {
    const track = this.querySelector('[data-track]');
    if (!track) return;

    hits.forEach(hit => {
      const url = `/collections/${hit.handle}`;
      const img = hit.image || '';
      const count = hit.products_count || 0;

      const card = document.createElement('a');
      card.href = url;
      card.className = 'acr__card';
      card.innerHTML = `
        <div class="acr__img-wrap">
          ${img ? `<img src="${img}" alt="${hit.title.replace(/"/g, '&quot;')}" width="120" height="120" loading="lazy">` : `<span class="acr__placeholder"></span>`}
        </div>
        <div class="acr__info">
          <p class="acr__title">${hit.title}</p>
          <span class="acr__count">${count} ${this.dataset.productsLabel || 'products'}</span>
        </div>`;
      track.appendChild(card);
    });
  }
}

if (!customElements.get('algolia-collection-results')) {
  customElements.define('algolia-collection-results', AlgoliaCollectionResults);
}
